<ng-template #header>
  <div nz-col nzFlex="auto">
    <form
      nz-form
      [nzLayout]="'inline'"
      [formGroup]="searchForm"
      (ngSubmit)="search()"
    >
      <beautyapp-input
        formControlName="search"
        placeholder="{{'search.searchWord' | translate }}"
        prefixIcon="search"
      ></beautyapp-input>
      <beautyapp-input
        formControlName="generic"
        placeholder="{{'ERX.product.ProductGeneric' | translate }}"
      ></beautyapp-input>
      <beautyapp-input
        formControlName="actElement"
        placeholder="{{'ERX.product.Api' | translate }}"
      ></beautyapp-input>
      <nz-space>
        <button
          *nzSpaceItem
          nz-button
          nzType="primary"
          nzSize="small"
          nzShape="circle"
          [disabled]="!searchForm.valid"
        >
          <i nz-icon nzType="search" nzTheme="outline"></i>
        </button>
        <button
          *nzSpaceItem
          nz-button
          nzSize="small"
          nzShape="circle"
          type="button"
          (click)="clearSearch()"
        >
          <i nz-icon nzType="close" nzTheme="outline"></i>
        </button>
      </nz-space>
    </form>
  </div>
</ng-template>

<nz-table
  [nzTitle]="header"
  nzShowSizeChanger
  [nzData]="drugs()"
  [nzFrontPagination]="false"
  [nzLoading]="loading()"
  [nzTotal]="totalItems()"
  [nzPageSize]="pageSize()"
  [nzPageIndex]="page()"
  (nzQueryParams)="paginatorChange($event)"
  [nzPageSizeOptions]="[5, 10, 20, 50, 100]"
  nzSize="small"
>
  <thead>
  <tr>
    <th >
      {{'ERX.product.productID' | translate}}
    </th>
    <th >
      {{'ERX.product.GeoTradeName' | translate}}
    </th>
    <th >
      {{'ERX.product.ProductGeneric' | translate}}
    </th>
    <th >
      {{'ERX.product.IssuanceMode' | translate}}
    </th>
    <th>
      {{'ERX.product.Api' | translate}}
    </th>
    <th nzRight nzWidth="80px" class="transaction-delete-td"></th>
  </tr>
  </thead>
  <tbody>
    @for (row of drugs(); track $index) {
      <tr>
        <td>{{ row?.productId }}</td>
        <td>{{ row?.geoTradeName }}</td>
        <td>{{ row?.productGeneric }}</td>
        <td>{{ row?.issuanceMode }}</td>
        <td>{{ row?.api }}</td>
        <td nzRight>
          <ng-template #drugInfo>
            <div class="tst">
              <p class="list-item-split">{{'ERX.medicamentId' | translate}}: {{row?.productID}}</p>
              <p class="list-item-split">{{'ERX.product.GeoNDC' | translate}}: {{row?.geoNDC}}</p>
              <p class="list-item-split">{{'ERX.product.AtcCode' | translate}}: {{row?.atcCode}}</p>
              <p class="list-item-split">{{'ERX.product.IssuanceMode' | translate}}: {{row?.issuanceMode}}</p>
              <p class="list-item-split">{{'ERX.product.GeoTradeName' | translate}}: {{row?.geoTradeName}}</p>
              <p class="list-item-split">{{'ERX.product.EngTradeName' | translate}}: {{row?.engTradeName}}</p>
              <p class="list-item-split">{{'ERX.product.ProductGeneric' | translate}}: {{row?.productGeneric}}</p>
              <p class="list-item-split">{{'ERX.product.Api' | translate}}: {{row?.api}}</p>
              <p class="list-item-split">{{'ERX.product.PharmaTherapyGroup' | translate}}: {{row?.pharmaTherapyGroup}}</p>
              <p class="list-item-split">{{'ERX.product.Manufacturer' | translate}}: {{row?.manufacturer}}</p>
              <p class="list-item-split">{{'ERX.product.ManufacturerCountryName' | translate}}: {{row?.manufacturerCountryName}}</p>
              <p class="list-item-split">{{'ERX.product.RegistrationTill' | translate}}: {{row?.registrationTill}}</p>
              <p class="list-item-split">{{'ERX.product.OtherDetailsGeo' | translate}}: {{row?.otherDetailsGeo}}</p>
              <p class="list-item-split">{{'ERX.product.OtherDetailsEng' | translate}}: {{row?.otherDetailsEng}}</p>
              <p class="list-item-split">{{'ERX.product.DisableReason' | translate}}: {{row?.disableReason}}</p>
            </div>
          </ng-template>
          <nz-space>
            <button nz-button *nzSpaceItem class="action_btn">
              <span nz-icon nzType="info-circle" nzTheme="outline" nz-popover [nzPopoverContent]="drugInfo" style="color: #4AC1E0"></span>
            </button>
          <button
            *nzSpaceItem
            (click)="productSelected(row)"
            nz-button
            nzType="primary"
            nzShape="circle"
          >
            <nz-icon nzType="right" nzTheme="outline" />
          </button>
          </nz-space>
        </td>
      </tr>
    }
  </tbody>
</nz-table>
